



























































import Vue from 'vue';
import { footerNavigationUrl } from '@/constants';

export default Vue.extend({
  name: 'Footer',
  components: {},
  data () {
    return {
      footerNavigationUrl
    };
  },
  props: {
    footerData: {
      type: Object,
      required: true
    }
  }
})
